enum XComOptions {
    OnlyShowAccessWithoutConsent
}

export { XComOptions };
